import { render, staticRenderFns } from "./MagnifyMinusOutline.vue?vue&type=template&id=6b47cb72"
import script from "./MagnifyMinusOutline.vue?vue&type=script&lang=js"
export * from "./MagnifyMinusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports